export const TEXT_CLOSE = "閉じる";
export const TEXT_CANCEL = "キャンセル";
export const TEXT_SAVE = "保存";
export const TEXT_NO = "いいえ";
export const TEXT_COLOR = "カラー";
export const TEXT_SIZE = "サイズ";
export const ID_RING_TYPE_DEFAULT = 3;
export const RODEO_TYPE = 5;
export const CHARM_TYPE = 6;
export const RING_SIZE_DEFAULT = 100;
export const RING_COLOR_DEFAULT = "#000000";
export const IMAGE_HEIGHT_DEFAULT = 108;
export const MAX_WIDTH_SP = 1024;

export const TYPE_NEXT_SAVE = 1;
export const TYPE_NEXT_PURCHASE = 2;

export const BRACELET_TYPE_ID = 3; // vong tay
export const ANKLET_TYPE_ID = 4; // vong chan
export const NECKLACE_TYPE_ID = 2; // vong co
export const EARRINGS_TYPE_ID = 7; // bong tai

export const RODEO_ID = 4;
export const CHARM_ID = 5;

export const URL_IMG =
  "https://pasral.s3.ap-northeast-1.amazonaws.com/Product/ImageDesign/";
export const URL_SERVER = "https://pasral.jp";
export const URL_API = URL_SERVER + "/api";
export const URL_PURCHASE = URL_API + "/purchase";
export const URL_SAVE_DESIGN = URL_API + "/save-design";

// Mes error
export const MES_NOT_SELECED_RING =
  "商品をデザインする前に基本素材を選択してください。";
